var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FormWrapper",
    { attrs: { title: "Experience", body: "Add your Experience" } },
    [
      _c("UIButton", {
        staticClass: "flex justify-end mb-4",
        attrs: { icon: "plus", variant: "black", buttonText: "Add experience" },
        on: { click: _vm.showModal },
      }),
      _c(
        "LoadingOverlay",
        {
          attrs: {
            hasData: !!_vm.experiences,
            loading: _vm.$apollo.queries.experiences.loading,
          },
        },
        _vm._l(_vm.experiences, function (experience) {
          return _c("ProfileExperienceCard", {
            key: experience.id,
            staticClass: "mt-4",
            attrs: { experience: experience, userId: _vm.userId },
            on: { updated: _vm.refresh, removed: _vm.refresh },
          })
        }),
        1
      ),
      _vm.isModalOpen
        ? _c("ExperienceModal", {
            attrs: { userId: _vm.userId },
            on: { added: _vm.refresh },
            model: {
              value: _vm.isModalOpen,
              callback: function ($$v) {
                _vm.isModalOpen = $$v
              },
              expression: "isModalOpen",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }